import { Tooltip } from 'antd'
import { SortOrder, ColumnProps } from 'antd/lib/table'
import { ReviewerAndEmployee } from '../../../types'
import PerText from '../../../components/custom_components/Text'
import { PerAvatarPlus } from '../../../components/custom_components/AvatarPlus'
import { NameDisplayPreference } from '../../../graphql/enum/name-display-preference.enum'
import { computeFullname } from '../../../shared/nameDisplayPreferencesUtil'

interface GetColumnsProps {
  t: any
  user: any
  formatDateShort: (utcDateString: string, utc?: boolean | undefined) => string | undefined
}

export const getReviewerTableColumns = ({ t, user, formatDateShort }: GetColumnsProps): ColumnProps<ReviewerAndEmployee>[] => {
  const infoText = (buName: string, companyName: string | null, level: string | null) => (
    <>
      {level ? t(`employee.contract.level.${level}`) : '-'}
      <br />
      {companyName} - {buName}
    </>
  )

  return [
    {
      key: 'reviewer-reviewer',
      title: (
        <Tooltip title={t('employeeList.table.employeeTooltip')}>{t('companySettingsView.reviewerTab.table.reviewer.heading')}</Tooltip>
      ),
      className: 'minWidth-column-xl',
      defaultSortOrder: 'ascend' as SortOrder,
      sorter: (rowA: ReviewerAndEmployee, rowB: ReviewerAndEmployee) => {
        const nameA = computeFullname(user.nameDisplayPreference, rowA.reviewer.firstName, rowA.reviewer.lastName)
        const nameB = computeFullname(user.nameDisplayPreference, rowB.reviewer.firstName, rowB.reviewer.lastName)
        return nameA.localeCompare(nameB)
      },
      render: (tableData: ReviewerAndEmployee) => (
        <PerAvatarPlus
          nameDisplayPreference={user.nameDisplayPreference as NameDisplayPreference}
          employeeId={tableData.reviewer.id}
          firstName={tableData.reviewer.firstName}
          lastName={tableData.reviewer.lastName}
          infoText={infoText(tableData.reviewer.buName, tableData.reviewer.companyName || null, tableData.reviewer.currentLevel || null)}
        />
      ),
    },
    {
      key: 'reviewer-employee',
      className: 'minWidth-column-xl',
      title: (
        <Tooltip title={t('employeeList.table.employeeTooltip')}>{t('companySettingsView.reviewerTab.table.employee.heading')}</Tooltip>
      ),
      sorter: (rowA: ReviewerAndEmployee, rowB: ReviewerAndEmployee) => {
        const nameA = computeFullname(user.nameDisplayPreference, rowA.employee.firstName, rowA.employee.lastName)
        const nameB = computeFullname(user.nameDisplayPreference, rowB.employee.firstName, rowB.employee.lastName)
        return nameA.localeCompare(nameB)
      },
      render: (tableData: ReviewerAndEmployee) => (
        <PerAvatarPlus
          nameDisplayPreference={user.nameDisplayPreference as NameDisplayPreference}
          employeeId={tableData.employee.id}
          firstName={tableData.employee.firstName}
          lastName={tableData.employee.lastName}
          infoText={infoText(tableData.employee.buName, tableData.employee.companyName || null, tableData.employee.currentLevel || null)}
        />
      ),
    },
    {
      key: 'reviewer-fromDate',
      title: t('companySettingsView.reviewerTab.table.fromDate.heading'),
      className: 'minWidth-column-s',
      sorter: (fromA: ReviewerAndEmployee, fromB: ReviewerAndEmployee) => {
        return fromA.fromDate && fromB.fromDate && fromA.fromDate.localeCompare(fromB.fromDate)
      },
      render: (tableData: ReviewerAndEmployee) => (
        <PerText color="secondary" fontSize="xs">
          {formatDateShort(tableData.fromDate, true)}
        </PerText>
      ),
    },
  ]
}
